import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { DynamicForm } from './DynamicForm';

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  entity: any;
  initialData?: any;
  onSubmit: (data: any) => Promise<void>;
  onCancel: () => void;
  loading?: boolean;
  dynamicOptions?: Record<string, any[]>;
}

export const EditModal: React.FC<EditModalProps> = ({
  isOpen,
  onClose,
  title,
  entity,
  initialData,
  onSubmit,
  onCancel,
  loading = false,
  dynamicOptions = {}
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[var(--color-surface-bg)] rounded-lg shadow-xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-[var(--color-border)]">
          <h3 className="text-lg font-semibold text-[var(--color-surface-text)]">{title}</h3>
          <button
            onClick={onClose}
            className="text-[var(--color-secondary-text)] hover:text-[var(--color-surface-text)] transition-colors"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          <DynamicForm
            entity={entity}
            initialData={initialData}
            onSubmit={onSubmit}
            onCancel={onCancel}
            loading={loading}
            dynamicOptions={dynamicOptions}
          />
        </div>
      </div>
    </div>
  );
};
